import { useQuery, UseQueryResult } from 'react-query';
import { fetchConfig } from '../../services/config.service';
import { Config } from '../../services/dtos/Config.dto';
import { queryKeys } from '../queryKeyFactory';

export default (): UseQueryResult<Config, Error> => {
  return useQuery<Config, Error>([queryKeys.config], () => fetchConfig(), { cacheTime: Infinity });
};
